import { type ReactNode } from "react";

export function Toggle({
  showOn,
  on,
  off,
}: {
  readonly showOn: boolean;
  readonly on: ReactNode;
  readonly off: ReactNode;
}) {
  return showOn ? on : off;
}
